export function deepOmitEmptyData<T>(value: T): T {
  if (Array.isArray(value)) {
    return value.map((item) => deepOmitEmptyData(item)) as T;
  }

  if (isObject(value)) {
    return Object.keys(value)
      .filter((key) => {
        const fieldValue = (value as Record<string, unknown>)[key];
        // Filter out null/undefined values
        if (fieldValue == null) {
          return false;
        }
        // Filter out empty strings
        if (fieldValue === '') {
          return false;
        }
        // Filter out empty arrays
        if (Array.isArray(fieldValue) && fieldValue.length === 0) {
          return false;
        }
        return true;
      })
      .reduce(
        (acc, key) => ({
          ...acc,
          [key]: deepOmitEmptyData((value as Record<string, unknown>)[key]),
        }),
        {} as T,
      );
  }

  return value;
}

function isObject(givenValue: any): givenValue is object {
  return (
    typeof givenValue === 'object' &&
    !Array.isArray(givenValue) &&
    givenValue !== null
  );
}
